// src/AppFooter.jsx
import React from "react";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import "../styles/footer.scss";

const AppFooter = () => {
  return (
    <footer className="app-footer">
      <div className="main-container">
        <div className="footer-section-1">
          <div>
            <h2 id="footer-header">Spremni da naručite uniformu?</h2>
            <p id="footer-description">
              Kontaktirajte nas i saznajte kako možemo da vam pomognemo da
              kreirate savršene uniforme za vaš tim.
            </p>
            <a href="/kontakt" className="btn-primary">
              Kontaktirajte nas
            </a>
          </div>
        </div>
        <div className="footer-section-2">
          <div className="App">
            <div className="footer-columns">
              <div className="footer-column">
                <h3>Navigacija</h3>
                <ul className="footer-nav">
                  <li>
                    <a href="/">Početna</a>
                  </li>
                  <li>
                    <a href="/o-nama">O nama</a>
                  </li>
                  <li>
                    <a href="/uniforme">Uniforme</a>
                  </li>
                  <li>
                    <a href="/galerija">Galerija</a>
                  </li>
                  <li>
                    <a href="/kontakt">Kontakt</a>
                  </li>
                </ul>
              </div>
              <div className="footer-column">
                <h3>Kontakt podaci</h3>
                <ul className="footer-contact">
                  <li>
                    Email:{" "}
                    <a href="mailto:office@unijana.rs">office@unijana.rs</a>
                  </li>
                  <li>
                    Telefon: <a href="tel:+381631833253">+381631833253</a>
                  </li>
                  <li>Address: Kruševac</li>
                </ul>
              </div>
              <div className="footer-column">
                <h3>Društvene mreže</h3>
                <ul className="footer-nav-social">
                  <li>
                    <a
                      target="__blank"
                      href="https://www.facebook.com/unijanauniforme"
                    >
                      <FaFacebookF />
                    </a>
                  </li>
                  <li>
                    <a
                      target="__blank"
                      href="https://www.instagram.com/unijanaclothing"
                    >
                      <FaInstagram />
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-column">
                <h3>Prava i politike</h3>
                <a href="/politika-privatnosti">Politika privatnosti</a>
              </div>
            </div>
            <div className="footer-trademark">
              <p>
                Unijana © 2024. Sva prava zadržana. Izrada{" "}
                <a
                  target="___blank"
                  style={{
                    color: "var(--primary-color)",
                    textDecoration: "none"
                  }}
                  href="https://www.brandone.rs"
                >
                  Brand One
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
